module.exports = "<app-modal *ngIf=\"displayModal\" class=\"modal-small\" [(visible)]=\"displayModal\">\n\n  <div class=\"acao-cancelar text-left\">\n    <div class=\"title\"> {{ mensagem.titulo }} </div>\n\n    <div class=\"type\">\n      <img src=\"assets/images/exclamation-triangle.svg\">\n    </div>\n\n    <div class=\"modal-container\">\n      <div class=\"text\" [innerHtml]=\"mensagem.mensagem | keepHtml\"></div>\n    </div>\n  </div>\n</app-modal>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/popup/popup.component.html
// module id = ./src/app/components/popup/popup.component.html
// module chunks = main